import { sendCPCLog } from '../../utils/common';
import * as cpcUtil from './cpcUtil';

/**
 * @export
 * @class SuperClickDeal
 * 애드몬 | 슈퍼클릭 | 연관상품
 */
export default class SuperClickDeal {
  constructor() {
    const welSuperClickContainer = $('[data-role=_wrapSuperClickContainer]');
    this.welSuperClick = $('[data-role=_wrapSuperClick]');

    if (
      !TMON.oApp.htStorage.intergratedDeals ||
      !TMON.oApp.htStorage.intergratedDeals.data ||
      !TMON.oApp.htStorage.intergratedDeals.data.SUPER_CLICK_DEALS ||
      !TMON.oApp.htStorage.intergratedDeals.data.SUPER_CLICK_DEALS.length
    ) {
      welSuperClickContainer.parent('.inner.center_grid').remove();
      return;
    }

    if (TMON.oApp.sPlatform === 'PW') {
      this.renderPcDeal();
      const anchors = [...this.welSuperClick.find('li > a')];
      cpcUtil.onFirstLoad(anchors.slice(0, 6));
    } else {
      this.renderMobileDeal();
      const anchors = [...this.welSuperClick.find('li > a')];
      cpcUtil.onFirstLoad(anchors.slice(0, 4));
      cpcUtil.onScrollEnd(this.welSuperClick.parent()[0]);
    }

    this.wrapSuperClickAnchors = this.welSuperClick.find('a');
    welSuperClickContainer.show();
    this.setEvent();
  }

  setEvent() {
    const elSuperClickAdText = $('#_superClickAdText');
    const elSuperClickAdLayer = $('#_superClickAdLayer');

    elSuperClickAdText.on('click', () => elSuperClickAdLayer.addClass('on'));
    elSuperClickAdLayer.on('click', () =>
      elSuperClickAdLayer.removeClass('on')
    );

    this.wrapSuperClickAnchors.on('click', (e) => {
      sendCPCLog([e.currentTarget], 'CLICK');
    });
  }

  renderPcDeal() {
    const {
      intergratedDeals: {
        data: { SUPER_CLICK_DEALS: admonRecommended },
      },
    } = TMON.oApp.htStorage;

    const tlArea = 'dealsuperclick';
    const sHtml = admonRecommended.map(
      (item, idx) => {
        const imgSrc = TMON.util.preventMixedContent(item.imageInfo.mobile3ColImageUrl);
        const isAd = !!item.admonClickUrl;
        return `
          <li>
            <a href="${this.getUrl(item)}" data-tlarea="${tlArea}" data-tlord="${idx + 1}" data-ad="${isAd}">
              <figure>
                <img src="${imgSrc}" alt="${item.titleName}" width="90" height="92">
                ${TMON.oApp.oTemplate.getMasking(item)}
                <span class="buy_count">
                  <em>${TMON.util.numberWithComma(item.dealMax.buyCount)}</em>개 구매
                </span>
              </figure>
              <div class="information-wrap">
                <strong class='deal_name'>${item.titleName}</strong>
                <div class="purchase_info">
                  ${TMON.oApp.oTemplate.getInterGratedDealsPriceType(item)}
                </div>
              </div>
            </a>
          </li>
        `;
    })
    .join('');

    this.welSuperClick.html(sHtml).show();
  }

  renderMobileDeal() {
    const {
      intergratedDeals: {
        data: { SUPER_CLICK_DEALS: admonRecommended },
      },
    } = TMON.oApp.htStorage;

    const tlCode = {};
    if (TMON.view_mode === 'app') {
      tlCode.area = 'ADADD';
    } else {
      tlCode.area = 'ADMDD';
    }

    const sHtml = admonRecommended.map(
      (item, idx) => {
        const isAd = !!item.admonClickUrl;
        return `
          <li>
            <a class="deallist_scroll_link" href="${this.getUrl(item)}" data-tlarea="${tlCode.area}" data-tlord="${idx + 1}" data-ad="${isAd}">
              <div class="deallist_scroll_item">
                <div class="thumb">
                  <img src=${item.imageInfo.mobile3ColImageUrl} alt=${item.titleName} />
                  ${TMON.oApp.oTemplate.getMasking(item)}
                </div>
                <div class="info">
                  <strong class="title">${item.titleName}</strong>
                  <div class="price">
                    ${TMON.oApp.oTemplate.getInterGratedDealsPriceType(item)}
                  </div>
                </div>
              </div>
            </a>
          </li>
        `;
      }
    );

    this.welSuperClick.html(sHtml).show();
  }

  getUrl(item) {
    return TMON.util.aup(
      `${item.admonClickUrl}&fwUrl=${encodeURIComponent(
        TMON.util.aup(
          `${TMON.htLocal.htURL.www_m_deals}${item.dealNo}`,
          TMON.sAppQuery
        )
      )}`,
      TMON.sAppQuery
    );
  }
}
